import { Component, OnInit, Input, AfterViewInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EpbtFaQuickTransferService } from '../../services/epbt-fa-quick-transfer.service';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpButtonType, EpButtonStyle, IEpNumericBoxModel, EpNumericBoxComponent, EpEventService } from '@epicor/kinetic';
import { Router } from '@angular/router';
import { PageNames, TallyValidationResult, TallyValidationResultDescription, ProductType, CustomEvents } from 'ep-bt-controls';
import { EpbtFaQuickPurchaseService } from '../../services/epbt-fa-quick-purchase.service';
import { FieldAgentClient, QuickPurchase, Per, Product, Product2, QuickPurchaseLine, QuantityFromTallyRequest, Tally, TallyPair, BranchAccessLevel,
  ProductPrice, ITally, IQuickPurchaseLine, ProductPer } from 'ep-bt-field-agent-proxy';
import { EpbtFaTallyModel } from '../../models/epbt-fa-tally.model';
import { EpbtFaQuickPurchaseProductQtyEntryLine } from '../../models/epbt-fa-quick-purchase-product-qty-entry-line.model';
import { EpbtFaQuickTransferLineModel } from '../../models/epbt-fa-quick-transfer-line-model';
import { Location } from '@angular/common';
import { EpbtFaQuickPurchaseLineModel } from '../../models/epbt-fa-quick-purchase-line.model';
import { EpbtFaProductPerListComponent } from '../../list/epbt-fa-product-per-list/epbt-fa-product-per-list.component';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-product-quantity-control',
  templateUrl: './epbt-fa-product-quantity-control.component.html',
  styleUrls: ['./epbt-fa-product-quantity-control.component.scss']
})
export class EpbtFaProductQuantityControlComponent implements OnInit, AfterViewInit {

  productQuantityForm: FormGroup;
  selectedPer: ProductPer;
  tallyLengths: string;
  // tallyString: string;
  quickPurchase: QuickPurchase;
  purchaseOrderLine: QuickPurchaseLine;
  tallyLength: number;
  tallyPieces: number;
  tallyText: string;
  tallyValidationInfoMsg: string;
  quantityField: number;
  @Input() productId: number;
  isQuantityWarning = false;
  EpButtonStyle = EpButtonStyle;
  EpButtonType = EpButtonType;
  branchId: number;
  displayHeader: string;
  submitted = false;
  decimalNum = 4;
  // tallyDetailsLengthDiv: boolean = true;
  isFocus = false;

  @ViewChild(EpbtFaProductPerListComponent, {static: false}) productPerListComponent: EpbtFaProductPerListComponent;
  @ViewChild(EpNumericBoxComponent, {static: false}) epNumericBoxComponent: EpNumericBoxComponent;

  constructor(
    private client: FieldAgentClient, private formBuilder: FormBuilder, private location: Location, private route: Router,
    private quicktransferService: EpbtFaQuickTransferService, private productService: EpbtFaProductService,
    private quickPurchaseService: EpbtFaQuickPurchaseService, public epEvent: EpEventService) {

    this.epEvent.onEvents([CustomEvents.NegotiationControlNumericBoxFocus]).subscribe(event => {
      this.setQtyNumericBoxFocus();
    });
  }

  ngOnInit() {
    this.productQuantityForm = this.formBuilder.group({
      'quantity': ['', Validators.required],
      'perValue': [''],
      'tallyText': ['']
    });

    if (this.productService.fromPage == PageNames.QuickTranferProductSearch) {
      this.displayHeader = 'Transfer Line Negotiation';
      if (this.quicktransferService.quickTransfer.sourceBranch) {
        this.branchId = this.quicktransferService.quickTransfer.sourceBranch.branchID;
      }
      // else
      // this.branchId=1;
      this.productQuantityForm.patchValue({
        quantity: 0,
      });
    } else if (this.productService.fromPage == PageNames.QuickPurchaseProductSearch) {
      this.displayHeader = 'PO Line Negotiation';
      if (this.quickPurchaseService.quickPurchase.branch) {
        this.branchId = this.quickPurchaseService.quickPurchase.branch.branchID;
      }
      if (this.quickPurchaseService.quickPurchaseLine && this.quickPurchaseService.quickPurchaseLine.tally) {
        this.tallyText = this.quickPurchaseService.quickPurchaseLine.tally.tallyString;
      }
      this.bindProductQtyEntryControl();
    }
    this.isFocus = true;
  }

  ngAfterViewInit() {
    // Quick Transfer
    if (this.quicktransferService.quickTransfer.quickTransferLines.length > 0) {
      const transferLine = this.quicktransferService.quickTransfer.quickTransferLines.find(item => item.lineNumber == this.quicktransferService.quickTransfer.selectedLineIndex);
      if (transferLine) {
        this.productQuantityForm.patchValue({
          quantity: transferLine.quantity,
        });
        this.productPerListComponent.selectedProductPerItem = transferLine.selectedPer ? transferLine.selectedPer : this.selectedPer;
        this.selectedPer = transferLine.selectedPer ? transferLine.selectedPer : this.selectedPer;
        this.bindLineData(transferLine);
      }
    } else if (this.quickPurchaseService.selectedProductsForBinding.length > 0 && this.quickPurchaseService.isNegotiationEdit) {
      const lineItem = this.quickPurchaseService.selectedProductsForBinding.find(item => item.product.productId == this.productId);
      if (lineItem) {
        this.productQuantityForm.patchValue({
          quantity: lineItem.quantity,
        });
        this.productPerListComponent.selectedProductPerItem = lineItem.selectedPer ? lineItem.selectedPer : this.selectedPer;
        this.selectedPer = lineItem.selectedPer ? lineItem.selectedPer : this.selectedPer;
        this.perDropDownSelectedIndexChange(this.quickPurchaseService.quickPurchaseLine);
      }
    }
  }

  get frmFields() { return this.productQuantityForm.controls; }


  onQuantityFieldChanged(event: any) {
    this.isQuantityWarning = false;
    const qty = event.target.value;
    if (qty && parseFloat(qty) > 99999) {
      this.isQuantityWarning = true;
    }
  }

  cancelContactClick() {
    if (!this.quicktransferService.isNegotiationEdit) {
      const index = this.quicktransferService.quickTransfer.quickTransferLines.findIndex(item => item.lineNumber == this.quicktransferService.quickTransfer.selectedLineIndex);
      if (index >= 0) {
        this.quicktransferService.quickTransfer.quickTransferLines.splice(index, 1);
      }
    }
    if (this.productService.fromPage == PageNames.QuickPurchaseProductSearch) {
      this.route.navigate(['/home/quickpurchase']);
    } else {
      this.route.navigate(['/home/quicktransfer']);
    }


  }

  onValueChange(selectedValue) {
    if (selectedValue) {
      this.selectedPer = selectedValue;
      if (this.productService.fromPage == PageNames.QuickTranferProductSearch) {
        const transferLine = this.quicktransferService.quickTransfer.quickTransferLines.find(item => item.lineNumber == this.quicktransferService.quickTransfer.selectedLineIndex);
        this.perDropDownSelectedIndexChange(transferLine);
      } else {
        this.perDropDownSelectedIndexChange(this.quickPurchaseService.quickPurchaseLine);
      }
    }
  }

  onSubmitQuantity() {
    this.submitted = true;
    // this.isQuantityWarning = false;
    if (!this.isQuantityWarning) {
      // Quick Purchase
      if (this.productService.fromPage == PageNames.QuickPurchaseProductSearch) {
        this.quickPurchaseService.quickPurchaseLine.selectedPer = this.selectedPer;
        this.quickPurchaseService.quickPurchaseLine.quantity = this.productQuantityForm.controls['quantity'].value;
        const qty = this.productQuantityForm.controls['quantity'].value;
        this.isQuantityWarning = false;
        if (qty > 0) {
          this.updatePurchaseOrderLineData((flag: boolean) => {
            const index = this.quickPurchaseService.selectedProductsForBinding.findIndex(x => x.lineNumber == this.quickPurchaseService.quickPurchaseLine.lineNumber);
            if (index != -1) {
              this.quickPurchaseService.selectedProductsForBinding[index] = this.quickPurchaseService.quickPurchaseLine;
            } else {
              this.quickPurchaseService.selectedProductsForBinding.push(this.quickPurchaseService.quickPurchaseLine);
            }

            this.quickPurchaseService.isNegotiationEdit = false;
            this.tallyText = this.productQuantityForm.controls['tallyText'].value; // Take changed value from textbox
            if (this.IsTallyValid()) {
              this.route.navigate(['/home/quickpurchase']);
            }
          });
        } else {
          if (qty == null) {
            this.isQuantityWarning = false;
          } else {
            this.isQuantityWarning = true;
          }
        }
      } else {
        // Quick Transfer
        const transferLine = this.quicktransferService.quickTransfer.quickTransferLines.find(item => item.lineNumber == this.quicktransferService.quickTransfer.selectedLineIndex);
        if (transferLine) {
          transferLine.quantity = this.productQuantityForm.controls['quantity'].value;
          transferLine.selectedPer = this.selectedPer;
          transferLine.isSave = true;
          if (transferLine.product.inputPers && transferLine.product.inputPers.length == 0) {
            transferLine.product.dateTimeCreated = new Date();
            transferLine.product.dateTimeLastModified = new Date();
            this.quicktransferService.loadProductsPers(transferLine.product, (outProduct: Product2) => {
              transferLine.product = outProduct ? outProduct : transferLine.product;
              transferLine.inputPer = transferLine.product.inputPers.find(per => per.perId == this.selectedPer.perID);
              transferLine.inputPerID = transferLine.inputPer.perId;
              transferLine.perID = transferLine.inputPerID != 0 ? transferLine.inputPerID : transferLine.product.inputPer.perId;
              this.updateQuickTransferLineData(transferLine);
            });
          } else {
            transferLine.inputPer = transferLine.product.inputPers.find(per => per.perId == this.selectedPer.perID);
            transferLine.inputPerID = transferLine.inputPer.perId;
            transferLine.perID = transferLine.inputPerID != 0 ? transferLine.inputPerID : transferLine.product.inputPer.perId;
            this.updateQuickTransferLineData(transferLine);
          }
        }
      }
    } else { return; }
  }

  private updateQuickTransferLineData(transferLine: EpbtFaQuickTransferLineModel) {
    this.quicktransferService.calculateCosts(transferLine, (prices: ProductPrice) => {
      transferLine.unitCostPrice = prices.unitCostPrice;
      transferLine.totalCost = prices.totalCostPrice;
      // transferLine.inputPer = transferLine.product.inputPers.find(per => per.perId == this.selectedPer.perID);
      // transferLine.inputPerID = transferLine.inputPer.perId;
      // transferLine.perID = transferLine.inputPerID != 0 ? transferLine.inputPerID : transferLine.product.inputPer.perId;
      const index: number = this.quicktransferService.quickTransfer.quickTransferLines.findIndex(item => item.lineNumber == this.quicktransferService.quickTransfer.selectedLineIndex);
      this.quicktransferService.quickTransfer.quickTransferLines[index] = transferLine;
      this.route.navigate(['/home/quicktransfer']);
    });
  }


  commitTallyOnRefreshClick() {
    this.tallyValidationInfoMsg = '';
    this.isQuantityWarning = false;
    this.tallyText = this.productQuantityForm.controls['tallyText'].value;
    if (this.IsTallyValid()) {
      if (this.quickPurchaseService.quickPurchaseLine != null) {
        const tally = new EpbtFaTallyModel(this.tallyText);
        this.quickPurchaseService.quickPurchaseLine.tally = tally; // Set changes in service also
        // re-bind tally controls
        this.updateTallyControls(tally);
        // update Qty
        const newPer = this.quickPurchaseService.quickPurchaseLine.product.inputPers.find(per => per.perId == this.selectedPer.perID);
        if (newPer) {
          this.recalculateQuantityFromTally(newPer.perId);
        }
      }
    }
  }

  IsTallyValid(): boolean {
    let result = true;
    if (this.quickPurchaseService.quickPurchaseLine && this.productService.shouldTallyProduct(this.quickPurchaseService.quickPurchaseLine.product.tallyLengths)) {
      const splitedLengths = this.quickPurchaseService.quickPurchaseLine.product.tallyLengths.split(',');
      const tallyValidLengths = Array.from(new Set(splitedLengths.map((item: any) => item.trim())));

      if (this.tallyText != '' && tallyValidLengths.length > 0) {
        const tallyValidationResult: TallyValidationResult = EpbtFaTallyModel.validateTally(this.tallyText, tallyValidLengths);
        if (tallyValidationResult != TallyValidationResult.IsValid) {
          // display tally validation details here
          const msg = EpbtFaTallyModel.getDescription(TallyValidationResultDescription, tallyValidationResult);
          this.tallyValidationInfoMsg = '* ' + msg;
          this.tallyLength = 0;
          this.tallyPieces = 0;
          // this.tallyDetailsLengthDiv = false;
        }
        result = tallyValidationResult == TallyValidationResult.IsValid;
        // this.tallyDetailsLengthDiv = true;
      } else {
        // style = "none";
        // tallyValidationInfoStyle = "none";
      }
      // hide or show tally details
      // this.TallyValidationInfoDiv.Style["display"] = tallyValidationInfoStyle;
      // this.TallyDetailsLengthDiv.Style["display"] = style;
      // this.TallyDetailsPiecesDiv.Style["display"] = style;
    }
    return result;
  }

  updatePurchaseOrderLineData(subscribe: (flag: any) => void) {
    const selectedQuickPurchaseLine = this.quickPurchaseService.quickPurchaseLine;
    selectedQuickPurchaseLine.quantity = this.productQuantityForm.controls['quantity'].value;
    const per = selectedQuickPurchaseLine.product.inputPers.find(per => per.perId == this.selectedPer.perID);
    selectedQuickPurchaseLine.inputPer = per;

    // Update quantity and inputPer into service
    this.quickPurchaseService.quickPurchaseLine.quantity = selectedQuickPurchaseLine.quantity;
    this.quickPurchaseService.quickPurchaseLine.inputPer = selectedQuickPurchaseLine.inputPer;

    if (selectedQuickPurchaseLine.isTallyLine) {
      let tally = new EpbtFaTallyModel();
      tally = this.quickPurchaseService.quickPurchaseLine.tally;

      const splitedLengths = selectedQuickPurchaseLine.product.tallyLengths.split(',');
      const tallyValidLengths = Array.from(new Set(splitedLengths.map((item: any) => item.trim())));

      if (EpbtFaTallyModel.validateTally(tally.tallyString, tallyValidLengths) == TallyValidationResult.IsValid) {
        const per = selectedQuickPurchaseLine.product.inputPers.find(per => per.perId == this.selectedPer.perID);
        // assuming tally was entered, but not commited( commit button was not clicked), recalculate qty from Tally
        const quantityFromTallyRequest: Array<QuantityFromTallyRequest> = [];
        const tallyRequest = new QuantityFromTallyRequest();
        tallyRequest.lineNumber = selectedQuickPurchaseLine.lineNumber;
        tallyRequest.productID = selectedQuickPurchaseLine.product.productId;
        tallyRequest.quantityTally = tally.tallyString;
        tallyRequest.quantityPerID = per.perId;
        tallyRequest.thickness = selectedQuickPurchaseLine.product.thickness;
        tallyRequest.width = selectedQuickPurchaseLine.product.width;
        tallyRequest.precision = 4;
        quantityFromTallyRequest.push(tallyRequest);

        this.client.getQuantitiesFromTallies(quantityFromTallyRequest).subscribe(resQty => {
          if (resQty != null) {
            selectedQuickPurchaseLine.quantity = resQty[0].quantity;
            selectedQuickPurchaseLine.quantityTally = tally.tallyString;
            // selectedQuickPurchaseLine.tally.isPackTally = tally.isPackTally;
          }
          //    //Update quantity and quantityTally into service
          this.quickPurchaseService.quickPurchaseLine.quantity = this.productQuantityForm.controls['quantity'].value; // t// //selectedQuickPurchaseLine.quantity;
          this.quickPurchaseService.quickPurchaseLine.quantityTally = selectedQuickPurchaseLine.quantityTally;
          subscribe(true);
        });
      } else {
        subscribe(true);
      }
    } else {
      subscribe(true);
    }
  }

  bindProductQtyEntryControl() {
    // display tallyLengths if there
    if (this.productService.selectedProductItem.tallyLengths) {
      this.tallyLengths = this.productService.selectedProductItem.tallyLengths;
    }
    let selectedQuickPurchaseLine: EpbtFaQuickPurchaseLineModel;
    if (PageNames.QuickPurchaseProductSearch) {
      selectedQuickPurchaseLine = this.quickPurchaseService.quickPurchaseLine;
    }
    this.bindLineData(this.quickPurchaseService.quickPurchaseLine);
  }

  bindLineData(transferLine) {
    // transferLine.product.dateTimeLastModified = new Date();
    transferLine.product.dateTimeCreated = new Date();
    transferLine.product.dateTimeLastModified = new Date();
    this.client.loadProductPers(transferLine.product).subscribe(res => {

      if (res != null) {
        transferLine.product = res;
        console.log('loadProductPers' + JSON.stringify(res));
      }
      this.decimalNum = 4;
      if (this.selectedPer) {
        if (this.selectedPer.name == 'Each' || this.selectedPer.name == 'Lineal Foot') {
          transferLine.quantity = Math.round(transferLine.quantity);
          this.decimalNum = 4;   // need to confirm
        }
      }
      this.productQuantityForm.patchValue({// patchValue of line.quantity
        quantity: transferLine.quantity,
      });

      if (this.productService.shouldTallyProduct(transferLine.product.tallyLengths)) {
        // bind tally controls here
        this.updateTallyControls(this.quickPurchaseService.quickPurchaseLine.tally);
        // Show Tally
        // this.setTallyVisibility(true);
      } else {
        if (this.quickPurchaseService.quickPurchaseLine.tally) {
          this.updateTallyControls(this.quickPurchaseService.quickPurchaseLine.tally);
        }
        // Not tallied product, hide Tally
        // this.setTallyVisibility(false);
      }

      if (transferLine.per && (transferLine.product.inputPers && transferLine.product.inputPers.length > 0)) {
        transferLine.per = transferLine.product.inputPers[0];
        transferLine.perID = transferLine.per.perId;
      }
    });

  }

  updateTallyControls(tally: any) {
    this.productQuantityForm.patchValue({
      tallyText: tally.tallyString,
    });
    this.tallyLength = tally.totalTallyLength.toFixed(4);
    this.tallyPieces = tally.totalTallyPieces;
  }

  recalculateQuantityFromTally(newPerID: number) {
    let thickness, width;
    thickness = this.quickPurchaseService.quickPurchaseLine.product.thickness.toFixed(8);
    width = this.quickPurchaseService.quickPurchaseLine.product.width.toFixed(8);
    const quantityFromTallyRequest: QuantityFromTallyRequest[] = [];
    const tallyRequest = new QuantityFromTallyRequest();
    tallyRequest.lineNumber = this.quickPurchaseService.quickPurchaseLine.lineNumber;
    tallyRequest.productID = this.quickPurchaseService.quickPurchaseLine.product.productId;
    tallyRequest.quantityTally = this.quickPurchaseService.quickPurchaseLine.tally.tallyString;
    // tallyRequest.quantityPerID = this.quickPurchaseService.quickPurchaseLine.inputPer.perId;
    tallyRequest.quantityPerID = newPerID;
    tallyRequest.thickness = this.quickPurchaseService.quickPurchaseLine.product.thickness;
    tallyRequest.width = this.quickPurchaseService.quickPurchaseLine.product.width;
    tallyRequest.precision = 4;
    quantityFromTallyRequest.push(tallyRequest);

    this.client.getQuantitiesFromTallies(quantityFromTallyRequest).subscribe(resQty => {
      if (resQty != null) {
        const qty = resQty[0].quantity.toFixed(4);
        // this.quickPurchaseService.quickPurchaseLine.quantity = Number(qty);//update quantity again in ProductQtyEntryLine
        this.productQuantityForm.patchValue({
          quantity: Number(qty) // show value on quantity Textbox.
        });
      }
    });
  }
  perDropDownSelectedIndexChange(transferLine) {
    const oldPerID: number = transferLine.inputPer.perId;
    const newPer = transferLine.product.inputPers.find(per => per.perId == this.selectedPer.perID);
    const newPerID: number = newPer.perId;

    // if (this.productService.fromPage == PageNames.QuickPurchaseProductSearch && transferLine.quantity != 0 && !this.quickPurchaseService.isNegotiationEdit)
    //   transferLine.inputPer = newPer;

    if (this.tallyText) {
      this.recalculateQuantityFromTally(newPerID);
    } else {
      if (this.IsTimberProduct(transferLine.product)) {
        this.client.getPerConversion(oldPerID, newPerID,
          transferLine.product.productId,
          transferLine.product.imperial,
          transferLine.product.thickness,
          transferLine.product.width,
          transferLine.product.length,
          transferLine.product.weight).subscribe(res => {
            transferLine.quantity = transferLine.quantity * res;
            this.decimalNum = 4;
            if (newPer.name == 'Lineal Foot') {
              transferLine.quantity = Math.round(transferLine.quantity);
              this.decimalNum = 4;   // need to confirm
            }
            this.productQuantityForm.patchValue({
              quantity: transferLine.quantity
            });
          });
      }
    }
  }
  IsTimberProduct(product: Product): boolean {
    let validTimberProductTypes: number[];
    validTimberProductTypes = [ProductType.TimberSheetMaterial, ProductType.TimberTallied, ProductType.TimberVariableWidth];
    return validTimberProductTypes.indexOf(product.productType) != -1 ? true : false;
  }

  setQtyNumericBoxFocus() {
    this.epNumericBoxComponent.setFocus();
  }
}

